module.exports = __webpack_public_path__ + "img/logo-13.1ea09a3c.png";